// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__Smq3v","Blue":"Button_Blue__DEuXQ","White":"Button_White__LTdfn"};